import React, { useState, useContext } from "react";
import Login from "../login/login";
import Signup from "../login/Signup";
import { Account } from "../login/Account";
// import Status from "../login/Status";
import Box from '@mui/material/Box';
import Navbar from '../../Navbar';
import Stack from '@mui/material/Stack';
import Sidemenu from '../../Sidemenu';
import FileUploadPage from '../FileUploadPage';
import DMSMainPage from "../../DMSMainPage";
export const Home = () => {


    return (
        <div>
            <Account>
                <div>
                    <Stack direction={"row"} justifyContent={"space-between"}>
                        <FileUploadPage />
                    </Stack>
                </div>
            </Account>
        </div>

    );

};
